import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="Footer">
      <div className="Footer-container">
        <Link to="/terms" className="Footer-link">Terms of Service</Link>
      </div>
    </footer>
  );
}

export default Footer;
